export default {
  selectedPreviewCard: null,

  selectedPreviewPageIndex: 0,

  isStudentAssignmentPreview: false,

  isClassAssignmentPreview: false,

  isPagePreview: false,

  busy: false,

  activeEditorId: null,

  activeEditorLocation: null,
};
